<template>
  <div>
    <b-modal :id="`bv-modal-shipping-address`" size="lg" hide-footer>
      <template #modal-title>Collection address</template>

    <div class="alert alert-warning py-2 text-center" role="alert">This is the address where we collect your products to deliver to customers.<br>Please make sure it's correct.</div>

      <div class="row">
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Business Name</label>
            <input class="form-control2" v-model="address.business_name">
        </div>
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2"><i class="fab fa-whatsapp mr-2"></i>Mobile Phone Number</label>
            <input class="form-control2" v-model="address.business_phone">
        </div>
      </div>
    
    
      <div class="row">
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Building Name <small>(Optional)</small></label>
            <input class="form-control2" v-model="address.business_building">
        </div>
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Unit Number <small>(optional)</small></label>
            <input class="form-control2" v-model="address.business_unit_number">
        </div>
      </div>

      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">Street Address</label>
            <input class="form-control2" v-model="address.business_address">
        </div>
      </div>

      <div class="row">
         <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Suburb</label>
            <input class="form-control2" v-model="address.business_suburb">
        </div>
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Postal Code</label>
            <input class="form-control2" v-model="address.business_postal_code">
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">City</label>
            <input class="form-control2" v-model="address.business_city">
        </div>
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Province</label>
            <select class="form-control2" v-model="address.business_province">
                <option value="Eastern Cape">Eastern Cape</option>
                <option value="Free State">Free State</option>
                <option value="Gauteng">Gauteng</option>
                <option value="KwaZulu-Natal">KwaZulu-Natal</option>
                <option value="Limpopo">Limpopo</option>
                <option value="Mpumalanga">Mpumalanga</option>
                <option value="North West">North West</option>
                <option value="Northern Cape">Northern Cape</option>
                <option value="Western Cape">Western Cape</option>
            </select>
        </div>
      </div>

      <div class="row">
        <div class="col">
            <label class="form-label pt-2 mb-2">Country</label>
            <select class="form-control2" v-model="address.business_country">
                <option value="ZA">South Africa</option>
            </select>
        </div>
      </div>

      <div class="row mt-3 pb-2">
        <div class="col">
                  <div>
<button v-if="updating" type="button" class="btn btn-success submit col">
  <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
        <button v-else type="button" class="btn btn-danger submit col" @click="saveAddress">Save Address</button>
      </div>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {

  data() {
    return {
      address: {},
      updating: false,
    };
  },

    created() {
        this.getShippingAddress();
    },

  methods: {

    getShippingAddress() {
      axios.get('/sales/shipping-address')
        .then((response) => {
          this.address = response.data;
        });
    },

    hideModalShippingAddress() {
      this.$bvModal.hide('bv-modal-shipping-address');
    },

            saveAddress() {
              if (!this.address.business_name) { this.sweetfire('Please enter business name') }
              else if (!this.address.business_address) { this.sweetfire('Please enter business address') }
              else if (!this.address.business_suburb) { this.sweetfire('Please enter suburb') }
              else if (!this.address.business_city) { this.sweetfire('Please enter city') }
              else if (!this.address.business_postal_code) { this.sweetfire('Please enter postal code') }
              else if (!this.address.business_province) { this.sweetfire('Please select province') }
              else if (!this.address.business_country) { this.sweetfire('Please select country') }
              else if (!this.address.business_phone) { this.sweetfire('Please enter business phone') }

            else {

              this.updating = true;

              axios.post('/address/update-shipping', {address: this.address})
                .then((response) => {

                if (response.data.success) {
                    console.log(response.data)
                    EventBus.$emit('update-address', this.product);
                    this.successAlert(response.data.message);
                    this.hideModalShippingAddress();
                } else {
                    this.sweetfire(response.data.message);
                }

                this.updating = false;

                });

          }

      },

      // sweet alert for 3 seconds
      successAlert(text) {

        Swal.fire({
            title: text,
            customClass: {
                // title: "confirm-title",
                title: "popup-title",
                icon: 'custom-icon-size'
            },
            icon: 'success',
            showConfirmButton: false,
            timer: 3000,
            // customClass: {
            //     title: "popup-title",
            //     },
            });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>

<style scoped>
textarea.form-control { font-size: 0.9rem !important; }
</style>